import { getPlatformName } from '@/lib/platform';

/**
 * Dev-only badge showing current platform (Web / Android / iOS).
 * Renders nothing in production builds.
 */
export function PlatformIndicator() {
  if (import.meta.env.PROD) return null;

  const platform = getPlatformName();
  const label = platform.charAt(0).toUpperCase() + platform.slice(1);

  return (
    <div className="fixed bottom-1 left-1 z-50 rounded bg-black/70 px-2 py-0.5 text-[10px] font-mono text-white">
      {label}
    </div>
  );
}
